import React, { useContext, useState } from 'react';
import { Parallax } from "react-parallax";
import { Link } from "react-router-dom";
import { AppContext } from '../main';
const CURRENT_YEAR = new Date().getFullYear();



const Footer = (props) => {
    const {
        handleEditItem
    } = props

    const { appState
    } = useContext(AppContext);
    const {
        footers = {
            title: ` Lorem ipsum culpa tempor tempor eu laboris adipisicing sunt excepteur enim laborum
                            officia eiusmod laborum sint do aliqua incididunt est aute deserunt in elit non sed ut
                            velit ullamco aliquip. Nulla cupidatat elit amet sed labore ut et consequat nostrud
                            laboris aliqua ex est fugiat quis aliqua duis quis esse dolor laboris non duis sunt.`,
            services: [
                { name: "Thunder and City" },
                { name: "Mystic Racing Z" },
                { name: "Silent Wrath" },
                { name: "Funk Dungeon" },
                { name: "Galactic Oddsey" },
                { name: "Warfare Legend" },
            ],
            pages: [
                { name: "Warfare Legend" },
                { name: "Game Server" },
                { name: "Knowledgebase", },
                { name: "About Us" },
                { name: "Affiliates" },
                { name: "Locations" },
                { name: "News" },
            ],
            links: [
                { icon: "fa-facebook-f", path: "/" },
                { icon: "fa-twitter", path: "/" },
                { icon: "fa-discord", path: "/" },
                { icon: "fa-tiktok", path: "/" },
                { icon: "fa-youtube", path: "/" },
            ]
        }
        , editMode = false
    } = appState

    if (!(footers?.services
        && footers?.pages
        && footers?.links)
    ) {
        return null
    }


    return (
        <footer>
            <div className="container">
                <div className="row gx-5">
                    {/* About Section */}
                    <div className="col-lg-4">
                        <img src={footers.logo} alt="Playhost Logo" style={{
                            maxHeight: 100
                        }} />
                        <div className="spacer-20"></div>
                        <p>
                            {footers?.title}
                        </p>
                    </div>

                    {/* Links Section */}
                    <div className="col-lg-4">
                        <div className="row">
                            <div className="col-lg-6 col-sm-6">
                                <div className="widget">
                                    <h5>{footers?.header1}</h5>
                                    <ul>
                                        {footers?.services.map((game, index) => (
                                            <li key={index}>
                                                <Link to="/">{game.name}</Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-6 col-sm-6">
                                <div className="widget">
                                    <h5>{footers?.header2}</h5>
                                    <ul>
                                        {footers?.pages.map((page, index) => (
                                            <li key={index}>
                                                <Link to="/">{page.name}</Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Newsletter & Social Section */}
                    <div className="col-lg-4">
                        <div className="widget">
                            <h5>{footers?.header3}</h5>

                            <form action="blank.php" className="row form-dark" id="form_subscribe" method="post" name="form_subscribe">
                                <div className="col text-center">
                                    <input
                                        className="form-control"
                                        id="txt_subscribe"
                                        name="txt_subscribe"
                                        placeholder="Enter your email"
                                        type="text"
                                    />
                                    <Link to="/" id="btn-subscribe">
                                        <i className="arrow_right bg-color-secondary"></i>
                                    </Link>
                                    <div className="clearfix"></div>
                                </div>
                            </form>
                            <div className="spacer-10"></div>
                            <small>{footers?.emailMessage}</small>
                            <div className="spacer-30"></div>

                            {/* Social Media Links */}
                            <div className="widget">
                                {/* <h5>Follow Us on</h5> */}
                                <h5>{footers?.header3}</h5>
                                <div className="social-icons">
                                    {footers?.links.map((social, index) => (
                                        <Link key={index} to={social.path}>
                                            <i className={`fa-brands ${social.icon}`}></i>
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Subfooter */}
            <div className="subfooter">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-sm-6">{footers?.copyright}</div>
                        <div className="col-lg-6 col-sm-6 text-lg-end text-sm-start">
                            <ul className="menu-simple">
                                <li>
                                    <Link to="/">{footers?.terms}</Link>
                                </li>
                                <li>
                                    <Link to="/">{footers?.policy}</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
